import React from "react";
import "./Error.scss";
import error from "../assets/images/500.png";
const ErrorPage: React.SFC = ({ children }) => (
  <main className="page" style={{ backgroundImage: `url(${error})` }}>
    <details>
      <summary>Details</summary>
      {children}
    </details>
    <a href="/" className="link">
      Back to home
    </a>
  </main>
);

export default ErrorPage;
